<script lang="ts" setup>
import { BankNames } from "~/shared/constants";
import { ThemeType, SiteCode } from "~/shared/enum";
import { VueTelInput } from "vue-tel-input";
import { ref, onMounted } from "vue"; //진 20240514
import "vue-tel-input/vue-tel-input.css";
import type { ComponentSize, FormInstance, FormRules } from "element-plus";

const { cookieThemeType } = useTheme();
const { setIsSigninModal, setIsSignupModal, setAlert, signupSetting, setIsLoading, themeSetting } = useStore();

const isIdDoubleCheck = ref(false);
const isNickNameDoubleCheck = ref(false);
const isReferalCodeDoubleCheck = ref(false);
const isPhoneVerify = ref(false);
const checkedIdList = ref<any>([]);
const checkedNicknameList = ref<any>([]);
const checkedReferalCodeList = ref<any>([]);
const isCarrierModal = ref(false);

const isPhoneValid = ref(false);
const telInputOptions = ref({ placeholder: "전화번호를 입력해주세요.", maxlength: 11 });
const telDropdownOptions = ref({
    showDialCodeInList: true,
    showFlags: true,
    showDialCodeInSelection: true,
    disabled: true,
});

const signupFormRef = ref<null | HTMLFormElement>(null);
const signupForm = ref({
    user_id: "",
    nickname: "",
    password: "",
    user_cppw: "",
    phone: "",
    code: "",
    bank_name: "",
    bank_account: "",
    bank_owner: "",
    withdrawal_password: "",
    sms_code: "",
    carrier: "",
    birth1: "",
    birth2: "",
});

const checkCPPW = (rule: any, value: any, callback: any) => {
    if (value === "") {
        callback(new Error("비밀번호를 다시 확인하세요."));
    } else if (value !== signupForm.value.password) {
        callback(new Error("비밀번호가 다릅니다."));
    } else {
        callback();
    }
};

const rules = ref<FormRules<any>>(
    themeSetting.value.site_code == SiteCode.Arte
        ? {
              user_id: [
                  { required: true, message: "아이디를 입력하세요.", trigger: "change" },
                  { min: 3, max: 15, message: "3-15자 영문 또는 숫자로 입력하세요.", trigger: "change" },
                  { pattern: /^\S*$/, message: "띄어쓰기는 불가능합니다.", trigger: "change" },
                  { pattern: /^[A-Za-z0-9]+$/, message: "영문 또는 숫자로 입력하세요.", trigger: "change" },
              ],
              nickname: [
                  { required: true, message: "닉네임을 입력하세요.", trigger: "change" },
                  { pattern: /^\S*$/, message: "띄어쓰기는 불가능합니다.", trigger: "change" },
                  { min: 2, max: 15, message: "2-15자로 입력하세요.", trigger: "change" },
              ],
              password: [
                  { required: true, message: "비밀번호를 입력하세요.", trigger: "change" },
                  { min: 4, max: 20, message: "4-20자 영문 또는 숫자로 입력하세요.", trigger: "change" },
              ],
              withdrawal_password: [
                  { required: true, message: "출금 비밀번호를 입력하세요.", trigger: "change" },
                  { pattern: /^\S*$/, message: "띄어쓰기는 불가능합니다.", trigger: "change" },
                  { pattern: /^[A-Za-z0-9]+$/, message: "영문 또는 숫자로 입력하세요.", trigger: "change" },
                  { min: 4, max: 20, message: "4-20자 영문 또는 숫자로 입력하세요.", trigger: "change" },
              ],
              user_cppw: [
                  { required: true, message: "비밀번호를 다시 확인하세요.", trigger: "change" },
                  { min: 4, max: 20, message: "4-20자 영문 또는 숫자로 입력하세요.", trigger: "change" },
                  { validator: checkCPPW, trigger: "blur" },
              ],
              bank_owner: [{ required: true, message: "불일치시 출금이 제한됩니다.", trigger: "change" }],
              bank_name: [{ required: true, message: "은행명을 입력하세요.", trigger: "change" }],
              bank_account: [{ required: true, message: "출금 계좌번호를 입력해주세요.", trigger: "change" }],
              code: [
                  {
                      required: signupSetting.value.isReferCode ? true : false,
                      message: "인증코드를 입력해주세요.",
                      trigger: "change",
                  },
              ],
              carrier: [{ required: true, message: "통신사를 선택해주세요.", trigger: "change" }],
              birth1: [
                  { required: true, message: "주민등록번호를 입력해주세요.", trigger: "change" },
                  { min: 6, max: 6, message: "6자리수를 입력해주세요.", trigger: "change" },
              ],
              birth2: [
                  { required: true, message: "", trigger: "change" },
                  { min: 1, max: 1, message: "", trigger: "change" },
              ],
          }
        : {
              user_id: [
                  { required: true, message: "아이디를 입력하세요.", trigger: "change" },
                  { min: 3, max: 15, message: "3-15자 영문 또는 숫자로 입력하세요.", trigger: "change" },
                  { pattern: /^\S*$/, message: "띄어쓰기는 불가능합니다.", trigger: "change" },
                  { pattern: /^[A-Za-z0-9]+$/, message: "영문 또는 숫자로 입력하세요.", trigger: "change" },
              ],
              nickname: [
                  { required: true, message: "닉네임을 입력하세요.", trigger: "change" },
                  { pattern: /^\S*$/, message: "띄어쓰기는 불가능합니다.", trigger: "change" },
                  { min: 2, max: 15, message: "2-15자로 입력하세요.", trigger: "change" },
              ],
              password: [
                  { required: true, message: "비밀번호를 입력하세요.", trigger: "change" },
                  { min: 4, max: 20, message: "4-20자 영문 또는 숫자로 입력하세요.", trigger: "change" },
              ],
              withdrawal_password: [
                  { required: true, message: "출금 비밀번호를 입력하세요.", trigger: "change" },
                  { pattern: /^\S*$/, message: "띄어쓰기는 불가능합니다.", trigger: "change" },
                  { pattern: /^[A-Za-z0-9]+$/, message: "영문 또는 숫자로 입력하세요.", trigger: "change" },
                  { min: 4, max: 20, message: "4-20자 영문 또는 숫자로 입력하세요.", trigger: "change" },
              ],
              user_cppw: [
                  { required: true, message: "비밀번호를 다시 확인하세요.", trigger: "change" },
                  { min: 4, max: 20, message: "4-20자 영문 또는 숫자로 입력하세요.", trigger: "change" },
                  { validator: checkCPPW, trigger: "blur" },
              ],
              bank_owner: [{ required: true, message: "불일치시 출금이 제한됩니다.", trigger: "change" }],
              bank_name: [{ required: true, message: "은행명을 입력하세요.", trigger: "change" }],
              bank_account: [{ required: true, message: "출금 계좌번호를 입력해주세요.", trigger: "change" }],
              code: [
                  {
                      required: signupSetting.value.isReferCode ? true : false,
                      message: "인증코드를 입력해주세요.",
                      trigger: "change",
                  },
              ],
              carrier: [{ required: true, message: "통신사를 선택해주세요.", trigger: "change" }],
              birth1: [
                  { required: true, message: "생년월일을 입력해주세요.", trigger: "change" },
                  { min: 6, max: 6, message: "6자리수를 입력해주세요.", trigger: "change" },
              ],
              birth2: [
                  { required: true, message: "", trigger: "change" },
                  { min: 1, max: 1, message: "", trigger: "change" },
              ],
          },
);

const submit = () => {
    if (!signupFormRef.value) {
        return;
    }
    if (checkedIdList.value.length == 0) {
        setAlert({
            isShow: true,
            data: {
                type: "warning",
                message: "아이디 중복체크 확인 부탁드립니다.",
            },
        });
        return;
    }
    if (checkedNicknameList.value.length == 0) {
        setAlert({
            isShow: true,
            data: {
                type: "warning",
                message: "닉네임 중복체크 확인 부탁드립니다.",
            },
        });
        return;
    }
    if (checkedReferalCodeList.value.length == 0) {
        setAlert({
            isShow: true,
            data: {
                type: "warning",
                message: "추천코드 확인 부탁드립니다.",
            },
        });
        return;
    }
    if (signupSetting.value.isMobileVerify) {
        if (!isPhoneVerify) {
            setAlert({
                isShow: true,
                data: {
                    type: "warning",
                    message: "폰인증 확인 부탁드립니다.",
                },
            });
            return;
        }
    }
    signupFormRef.value.validate((valid: boolean) => {
        if (valid) {
            setIsLoading(true);
            useBaseFetch("auth/signup", {
                method: "POST",
                body: { ...signupForm.value, referral_code: signupForm.value.code },
            })
                .then(({ data }) => {
                    if (data.value) {
                        signupFormRef.value.resetFields();
                        handleClose();
                        setAlert({
                            isShow: true,
                            data: {
                                type: "success",
                                message: "가입이 완료되었습니다.",
                            },
                        });
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            return false;
        }
    });
};
const handleClose = () => {
    setIsSignupModal(false);
};

const handleSignin = () => {
    handleClose();
    setIsSigninModal(true);
};

const handleDoubleIdCheck = () => {
    signupFormRef.value.validateField("user_id", (valid: boolean) => {
        if (valid) {
            setIsLoading(true);
            useBaseFetch("auth/unique-check/id", {}, signupForm)
                .then(({ data }) => {
                    if (data) {
                        if (data.value === "true") {
                            isIdDoubleCheck.value = true;
                            checkedIdList.value.push(signupForm.value.user_id);
                            setAlert({
                                isShow: true,
                                data: {
                                    type: "error",
                                    message: "사용자 ID 를 사용할수 있습니다.",
                                },
                            });
                        } else {
                            setAlert({
                                isShow: true,
                                data: {
                                    type: "error",
                                    message: "사용자 ID 를 사용할수 없습니다.",
                                },
                            });
                        }
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    });
};

const handleDoubleNicknameCheck = () => {
    signupFormRef.value.validateField("nickname", (valid: boolean) => {
        if (valid) {
            setIsLoading(true);
            useBaseFetch("auth/unique-check/nickname", {}, signupForm)
                .then(({ data }) => {
                    if (data) {
                        if (data.value === "true") {
                            isNickNameDoubleCheck.value = true;
                            checkedNicknameList.value.push(signupForm.value.nickname);
                            setAlert({
                                isShow: true,
                                data: {
                                    type: "error",
                                    message: "사용자 닉네임을 사용할수 있습니다.",
                                },
                            });
                        } else {
                            setAlert({
                                isShow: true,
                                data: {
                                    type: "error",
                                    message: "사용자 닉네임을 사용할수 없습니다.",
                                },
                            });
                        }
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    });
};

const handleReferalCodeCheck = () => {
    signupFormRef.value.validateField("code", (valid: boolean) => {
        if (valid) {
            setIsLoading(true);
            useBaseFetch("auth/valid-check/referral-code", {}, signupForm)
                .then(({ data }) => {
                    if (data) {
                        if (data.value === "true") {
                            isReferalCodeDoubleCheck.value = true;
                            checkedReferalCodeList.value.push(signupForm.value.code);
                        } else {
                            setAlert({
                                isShow: true,
                                data: {
                                    type: "error",
                                    message: "추천코드를 사용할수없습니다.",
                                },
                            });
                        }
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    });
};

const handleSMS = () => {
    if (!signupForm.value.phone) {
        setAlert({
            isShow: true,
            data: {
                type: "warning",
                message: "전화번호를 입력해주세요.",
            },
        });
        return;
    }
    setIsLoading(true);
    useBaseFetch("auth/send-sms", {
        method: "POST",
        body: { phone: signupForm.value.phone, type: 1 },
    })
        .then(({ data }) => {
            if (data.value) {
                setAlert({
                    isShow: true,
                    data: {
                        type: "success",
                        message: "인증번호를 입력해주세요.",
                    },
                });
            }
        })
        .finally(() => {
            setIsLoading(false);
        });
};

const handleVerifySMS = () => {
    if (!signupForm.value.phone) {
        setAlert({
            isShow: true,
            data: {
                type: "warning",
                message: "전화번호를 입력해주세요.",
            },
        });
        return;
    }
    if (!signupForm.value.sms_code) {
        setAlert({
            isShow: true,
            data: {
                type: "warning",
                message: "인증코드를 입력해주세요.",
            },
        });
        return;
    }
    setIsLoading(true);
    useBaseFetch("auth/verify-phone", {
        method: "POST",
        body: { phone: signupForm.value.phone, code: signupForm.value.sms_code, type: 1 },
    })
        .then(({ data }) => {
            if (data.value === "true") {
                setAlert({
                    isShow: true,
                    data: {
                        type: "success",
                        message: "인증 되었습니다.",
                    },
                });
                isPhoneVerify.value = true;
            }
        })
        .finally(() => {
            setIsLoading(false);
        });
};

const handleCarrierOpen = () => {
    isCarrierModal.value = true;
};

const carrierSelected = (value: string) => {
    signupForm.value.carrier = value;
};

const handlePhoneValidate = (data: any) => {
    if (data.valid) {
        isPhoneValid.value = true;
    } else {
        isPhoneValid.value = false;
    }
};

// 도메인에 따른 레퍼럴 코드 자동 설정 //진 20240514
onMounted(() => {
    const domain = window.location.hostname;
    switch (domain) {
        case "wom-1.com":
            signupForm.value.code = "bwin";
            break;
        case "won-1.com":
            signupForm.value.code = "bts7";
            break;
        case "won-369.com":
            signupForm.value.code = "bet365";
            break;
        default:
            signupForm.value.code = "";
            break;
    }
});
</script>
<template>
    <div class="acount-form">
        <el-dialog
            :model-value="true"
            class="signup-dialog"
            align-center
            :show-close="false"
            @update:model-value="handleClose"
            :close-on-click-modal="false"
        >
            <button class="form-close-btn" @click="handleClose">
                <i class="las la-times la-2x"></i>
            </button>
            <template #header>
                <!--                <p class="logo-text">SAMPLE</p>-->
                <NuxtImg src="/images/logo-w.png" alt="logo" width="300" height="52" class="mx-auto" />
            </template>
            <el-form
                class="signup-form"
                label-position="top"
                id="signupFormModal"
                ref="signupFormRef"
                :model="signupForm"
                :rules="rules"
                @keydown.enter="submit()"
            >
                <div class="flex flex-col md:grid md:grid-cols-2 gap-2">
                    <div>
                        <el-form-item prop="user_id" required :label="$t('id')">
                            <el-input
                                class="double-check-input"
                                type="text"
                                :placeholder="$t('id')"
                                size="large"
                                v-model="signupForm.user_id"
                            >
                                <template #append>
                                    <template v-if="checkedIdList.includes(signupForm.user_id)">
                                        <button type="button" class="check-btn">
                                            <i class="las la-check la-1x"></i>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button type="button" class="double-check-btn" @click="handleDoubleIdCheck">
                                            중복체크
                                        </button>
                                    </template>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item prop="nickname" required :label="$t('Nickname')">
                            <el-input
                                class="double-check-input"
                                type="text"
                                :placeholder="$t('Nickname')"
                                size="large"
                                v-model="signupForm.nickname"
                            >
                                <template #append>
                                    <template v-if="checkedNicknameList.includes(signupForm.nickname)">
                                        <button type="button" class="check-btn">
                                            <i class="las la-check la-1x"></i>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button
                                            type="button"
                                            class="double-check-btn"
                                            @click="handleDoubleNicknameCheck"
                                        >
                                            중복체크
                                        </button>
                                    </template>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item prop="password" required :label="$t('password')">
                            <el-input
                                type="password"
                                :placeholder="$t('password')"
                                size="large"
                                v-model="signupForm.password"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item prop="user_cppw" required :label="$t('confirm-password')">
                            <el-input
                                type="password"
                                :placeholder="$t('confirm-password')"
                                size="large"
                                v-model="signupForm.user_cppw"
                            >
                            </el-input>
                        </el-form-item>
                    </div>

                    <div class="col-span-2">
                        <el-form-item prop="code" :required="signupSetting.isReferCode" :label="$t('Referral code')">
                            <el-input
                                class="double-check-input"
                                type="text"
                                :placeholder="$t('Referral code')"
                                size="large"
                                v-model="signupForm.code"
                            >
                                <template #append>
                                    <template v-if="checkedReferalCodeList.includes(signupForm.code)">
                                        <button type="button" class="check-btn">
                                            <i class="las la-check la-1x"></i>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button type="button" class="double-check-btn" @click="handleReferalCodeCheck">
                                            확인
                                        </button>
                                    </template>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <template v-if="!signupSetting.isMobileVerify">
                        <div class="col-span-1">
                            <div class="flex flex-col gap-1">
                                <vue-tel-input
                                    :autoFormat="false"
                                    mode="international"
                                    defaultCountry="kr"
                                    @validate="handlePhoneValidate"
                                    v-model="signupForm.phone"
                                    :inputOptions="telInputOptions"
                                    :dropdownOptions="telDropdownOptions"
                                ></vue-tel-input>
                                <span v-if="!isPhoneValid && signupForm.phone.length > 0" class="text-red-500"
                                    >휴대폰 번호의 형식이 잘못되었습니다.</span
                                >
                            </div>
                        </div>
                        <div class="col-span-1">
                            <el-form-item prop="carrier" required>
                                <el-input
                                    class="double-check-input"
                                    readonly
                                    type="text"
                                    placeholder="통신사를 선택해주세요."
                                    size="large"
                                    v-model="signupForm.carrier"
                                >
                                    <template #append>
                                        <button type="button" class="double-check-btn" @click="handleCarrierOpen">
                                            선택
                                        </button>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item prop="birth1" required label="생년월일">
                                <div class="flex items-center">
                                    <el-input
                                        type="text"
                                        placeholder="******"
                                        size="large"
                                        v-model="signupForm.birth1"
                                        maxlength="6"
                                    >
                                    </el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item prop="birth2" required label="주민번호 뒷자리">
                                <div class="flex items-center gap-2">
                                    <el-input
                                        type="text"
                                        placeholder="*"
                                        size="large"
                                        v-model="signupForm.birth2"
                                        maxlength="1"
                                        style="width: 60px"
                                    >
                                    </el-input>
                                    <span class="text-white">- ●●●●●●</span>
                                </div>
                            </el-form-item>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-span-2 flex gap-2 mb-3">
                            <div class="flex flex-col gap-1 w-[60%] md:w-[70%]">
                                <vue-tel-input
                                    :autoFormat="false"
                                    mode="international"
                                    defaultCountry="kr"
                                    @validate="handlePhoneValidate"
                                    v-model="signupForm.phone"
                                    :inputOptions="telInputOptions"
                                    :dropdownOptions="telDropdownOptions"
                                ></vue-tel-input>
                                <span v-if="!isPhoneValid && signupForm.phone.length > 0" class="text-red-500"
                                    >휴대폰 번호의 형식이 잘못되었습니다.</span
                                >
                            </div>
                            <button type="button" class="double-check-btn flex-1" @click="handleSMS">
                                인증번호 전송
                            </button>
                        </div>
                        <div class="col-span-2">
                            <el-form-item prop="carrier" required>
                                <el-input
                                    class="double-check-input"
                                    readonly
                                    type="text"
                                    placeholder="통신사를 선택해주세요."
                                    size="large"
                                    v-model="signupForm.carrier"
                                >
                                    <template #append>
                                        <button type="button" class="double-check-btn" @click="handleCarrierOpen">
                                            선택
                                        </button>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item prop="birth1" required label="생년월일">
                                <div class="flex items-center">
                                    <el-input
                                        type="text"
                                        placeholder="960101"
                                        size="large"
                                        v-model="signupForm.birth1"
                                        maxlength="6"
                                    >
                                    </el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item prop="birth2" required label="주민번호 뒷자리">
                                <div class="flex items-center gap-2">
                                    <el-input
                                        type="text"
                                        placeholder="0"
                                        size="large"
                                        v-model="signupForm.birth2"
                                        maxlength="1"
                                        style="width: 60px"
                                    >
                                    </el-input>
                                    <span class="text-white">- ●●●●●●</span>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="col-span-2">
                            <el-form-item prop="code" required label="인증코드">
                                <el-input
                                    class="double-check-input"
                                    type="text"
                                    placeholder="인증코드를 입력해주세요"
                                    size="large"
                                    v-model="signupForm.sms_code"
                                >
                                    <template #append>
                                        <template v-if="isPhoneVerify">
                                            <button type="button" class="check-btn">
                                                <i class="las la-check la-1x"></i>
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button type="button" class="double-check-btn" @click="handleVerifySMS">
                                                확인
                                            </button>
                                        </template>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </div>
                    </template>
                    <div>
                        <el-form-item prop="bank_name" required :label="$t('bank-name')">
                            <el-select v-model="signupForm.bank_name" placeholder="은행명을 선택하세요." size="large">
                                <el-option
                                    v-for="item in BankNames.map((x) => {
                                        return { value: x, label: x };
                                    })"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                    <div class="flex items-center gap-4">
                                        <img
                                            :src="`/images/banks/${item.value}.png`"
                                            :alt="item.value"
                                            width="20"
                                            height="20"
                                        />
                                        <span>{{ item.label }}</span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item prop="bank_owner" required :label="$t('account owner')">
                            <el-input
                                type="text"
                                :placeholder="$t('account owner')"
                                size="large"
                                v-model="signupForm.bank_owner"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item prop="bank_account" required :label="$t('account number')">
                            <el-input
                                type="text"
                                :placeholder="$t('account number')"
                                size="large"
                                v-model="signupForm.bank_account"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item prop="withdrawal_password" required :label="$t('Withdrawal Password')">
                            <el-input
                                type="password"
                                :placeholder="$t('Withdrawal Password')"
                                size="large"
                                v-model="signupForm.withdrawal_password"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="flex items-center justify-center">
                    <button class="submit-btn" type="button" @click="submit()">{{ $t("signup") }}</button>
                </div>
                <div class="flex items-center justify-center mt-2">
                    <p class="redirect-text" @click="handleSignin">{{ $t("login") }}</p>
                </div>
            </el-form>
        </el-dialog>
        <modal-carrier
            v-if="isCarrierModal"
            @close="isCarrierModal = false"
            @selected="carrierSelected"
            :value="signupForm.carrier"
        />
    </div>
</template>

<style scoped>
/* 플레이스홀더 색상을 글자 색상보다 연하게 설정하여 구분이 잘 되도록 함 */
:deep(.el-input__inner::placeholder) {
    color: rgba(255, 255, 255, 0.5) !important;
    opacity: 0.4;
}

:deep(.vti__input::placeholder) {
    color: rgba(255, 255, 255, 0.5) !important;
    opacity: 0.4;
}
</style>
